/*
 * wnf-collection-density-2026-06-17 — Collection grid-density toggle (City-Home-style "View").
 *
 * Client-side, CSS-driven. Density state = data-wnf-dz-d (desktop: 2|3|4) and
 * data-wnf-dz-m (mobile: 1|2) on <html>. The matching CSS in wnf-bundle.css re-flows each
 * collection card (desktop: flex-basis; mobile: the container's grid-template-columns) with NO
 * reload / refetch. It targets #CollectionAjaxContent, so it covers BOTH the server-rendered grid
 * AND the wnf-collection-search results grid.
 *
 * The pre-paint inline script in collection-toolbar.liquid already applied any SAVED density to
 * <html> before the grid painted (no flash). This deferred script:
 *   1. detects the collection's NATURAL default columns (from the server fraction class on desktop;
 *      from .wnf-mobile-1up on mobile) so the right button reads active even when nothing is saved,
 *   2. handles clicks → update <html> + localStorage + aria-pressed,
 *   3. arrow-key roving within each segmented set.
 *
 * The untouched default follows the collection and phone width. Every explicit shopper choice
 * persists; compact phones default to one card per row unless the shopper selects two.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var control = document.querySelector('[data-wnf-dz]');
  if (!control) return;

  var ATTR = { desktop: 'data-wnf-dz-d', mobile: 'data-wnf-dz-m' };
  var STORE = { desktop: 'wnf-density-desktop', mobile: 'wnf-density-mobile' };

  function injectCardImageVisibilityGuard() {
    if (document.getElementById('wnf-plp-card-image-visible-20260622')) return;
    var style = document.createElement('style');
    style.id = 'wnf-plp-card-image-visible-20260622';
    style.textContent = 'body.template-collection #CollectionAjaxContent .grid-product__image-mask image-element,body.template-collection #CollectionAjaxContent .grid-product__image-mask .image-element{opacity:1!important;transform:none!important;animation:none!important;transition:none!important;}';
    document.head.appendChild(style);
  }

  injectCardImageVisibilityGuard();

  // ── Natural (server) default columns, so the active pill matches what's actually on screen ──
  function naturalDesktop() {
    var card = document.querySelector('#CollectionAjaxContent .product-grid-container > .grid-product');
    if (card) {
      if (card.classList.contains('medium-up--one-half')) return '2';
      if (card.classList.contains('medium-up--one-third')) return '3';
      if (card.classList.contains('medium-up--one-quarter')) return '4';
      if (card.classList.contains('medium-up--one-fifth')) return '4'; // clamp 5→4 (control max)
    }
    return '4';
  }
  function naturalMobile() {
    var sec = document.getElementById('CollectionSection');
    return (window.matchMedia('(max-width: 360px)').matches || sec && sec.classList.contains('wnf-mobile-1up')) ? '1' : '2';
  }
  var DEFAULTS = { desktop: naturalDesktop(), mobile: naturalMobile() };

  function currentCols(view) {
    return root.getAttribute(ATTR[view]) || (view === 'mobile' ? naturalMobile() : DEFAULTS[view]);
  }

  function refreshGridReveal() {
    window.requestAnimationFrame(function () {
      if (window.AOS && typeof window.AOS.refreshHard === 'function') {
        window.AOS.refreshHard();
      } else if (window.AOS && typeof window.AOS.refresh === 'function') {
        window.AOS.refresh();
      }
      window.dispatchEvent(new Event('scroll'));
    });
  }

  function apply(view, cols) {
    root.setAttribute(ATTR[view], cols); // an explicit choice remains explicit across phone sizes
    try { localStorage.setItem(STORE[view], cols); } catch (e) {}
    sync();
    refreshGridReveal();
  }

  // Reflect current density into each button's aria-pressed + active class + roving tabindex.
  function sync() {
    var btns = control.querySelectorAll('.wnf-dz__btn');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var view = b.getAttribute('data-wnf-dz-view');
      var on = b.getAttribute('data-wnf-dz-cols') === currentCols(view);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
      b.tabIndex = on ? 0 : -1;
    }
  }

  control.addEventListener('click', function (e) {
    var btn = e.target.closest('.wnf-dz__btn');
    if (!btn || !control.contains(btn)) return;
    apply(btn.getAttribute('data-wnf-dz-view'), btn.getAttribute('data-wnf-dz-cols'));
  });

  // Arrow-key navigation within a segmented set (Left/Right/Up/Down, Home/End).
  control.addEventListener('keydown', function (e) {
    var btn = e.target.closest('.wnf-dz__btn');
    if (!btn) return;
    var btns = Array.prototype.slice.call(btn.parentNode.querySelectorAll('.wnf-dz__btn'));
    var i = btns.indexOf(btn), next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = btns[(i + 1) % btns.length];
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = btns[(i - 1 + btns.length) % btns.length];
    else if (e.key === 'Home') next = btns[0];
    else if (e.key === 'End') next = btns[btns.length - 1];
    if (!next) return;
    e.preventDefault();
    apply(next.getAttribute('data-wnf-dz-view'), next.getAttribute('data-wnf-dz-cols'));
    next.focus();
  });

  window.matchMedia('(max-width: 360px)').addEventListener('change', sync);
  sync();
})();
